/* src/app/shared/components/ag-input-field/ag-input-field.component.scss */
.main-component {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: fit-content;
  width: 314px;
}
.main-component .input-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #f2f2f2;
  min-height: 56px;
  border: 1px solid transparent;
}
.main-component .input-container-focused {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  min-height: 56px;
  cursor: text;
}
.main-component .ag-value {
  position: relative;
  height: 24px;
  display: flex;
  cursor: text;
}
.main-component .ag-value .label {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #5c5c5c;
  position: absolute;
  z-index: 2;
  cursor: text;
  transition: transform 0.2s ease-out, font-size 0.2s ease-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.main-component .ag-value .label.above {
  transform: translateY(-10px);
  font-size: 12px;
}
.main-component .ag-value .input {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #f2f2f2;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.main-component .ag-value .input::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #5c5c5c;
}
.main-component .ag-value .input-focused {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #ffffff !important;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
}
.main-component .input-img {
  height: 24px;
  width: 24px;
}
.main-component .info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.main-component .info-container .info-img {
  width: 12px;
  height: 12px;
  color: #222222;
}
.main-component .info-container .error-img {
  width: 12px;
  height: 12px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.main-component .info-container .info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 1px;
}
.numbered-main-component {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.numbered-main-component .inner-container {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.numbered-main-component .inner-container .numbered-input-container {
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #f2f2f2;
  border-radius: 12px;
}
.numbered-main-component .inner-container .numbered-input-container .numbered-input {
  height: 26px;
  width: 100%;
  float: right;
  font-size: 14px;
  border: none;
  outline: none;
  background-color: #f2f2f2;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
  text-align: center;
}
.numbered-main-component .info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.numbered-main-component .info-container .info-img {
  width: 12px;
  height: 12px;
  color: #222222;
}
.numbered-main-component .info-container .error-img {
  width: 12px;
  height: 12px;
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.numbered-main-component .info-container .info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 1px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.input:is(:-webkit-autofill) .label {
  transform: translateY(-10px);
  font-size: 12px;
}
/*# sourceMappingURL=ag-input-field.component.css.map */
